/** @jsxImportSource theme-ui */
import { Container, Heading, Text } from 'theme-ui';
import CreateInvoiceJob from '@/containers/voss/CreateInvoiceJob';
import { useParams, useNavigate } from 'react-router-dom';
import Section from '@/components/Section';

const CreateDiscountAgreementPage = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();

    return (
        <Container>
            <Heading sx={{ textTransform: 'capitalize' }} as="h2">
                Create VOSS invoice job
            </Heading>
            <Section>
                <Heading as="h3">Create VOSS invoice job</Heading>
                <CreateInvoiceJob onSubmitSuccess={() => navigate('/voss/invoices')} />
            </Section>
        </Container>
    );
};

export default CreateDiscountAgreementPage;
